import { TradeInRoot } from '@makemydeal/activities-tradein';
import { PageHeader, ShowroomCardContainer } from '@makemydeal/dr-sales-checkin-components';

const TradeIn = () => {
    return (
        <ShowroomCardContainer>
            <PageHeader isResponsive heading="Trade-In" />
            <TradeInRoot isSalesView={true} />
        </ShowroomCardContainer>
    );
};

export default TradeIn;
